export type AlertSummaryChangedEvent = {
  type: 'alerts.summary.changed';
  reason: string;
  alertId?: number;
};

type AlertRealtimeListener = (event: AlertSummaryChangedEvent) => void;

const listeners = new Set<AlertRealtimeListener>();

export function publishAlertRealtimeEvent(event: AlertSummaryChangedEvent) {
  listeners.forEach((listener) => {
    listener(event);
  });
}

export function subscribeToAlertRealtimeEvents(
  listener: AlertRealtimeListener,
) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
